module.exports = __webpack_public_path__ + "static/media/panicum-massai.ec6f5578.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/panicum-massai.jpg
// module id = 95
// module chunks = 0